import axios from "axios";
import Roles from '@/components/constants/roles'
import Term from '@/components/constants/mandateTerm'
import InJournalTypes from "@/components/constants/inJournalTypes.js"
import { hasRole } from "@/services/userService.js"

export function showComponents(name, inJournalType) {
  switch (inJournalType) {
    case InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA:
      return ['MessageDetails', 'DataProvider', 'ObjectData', 'Principals', 'Representitives', 'Documents', 'ConfirmPerson'].includes(name)

    case InJournalTypes.PRANESIMAS_APIE_PAKEITIMA:
      return [ 'MessageDetails', 'DataProvider', 'ObjectData', 'Principals', 'Representitives', 'Documents', 'ConfirmPerson', 'PowerOfAttorneyChangeData', 'ChangeConfirmPerson'].includes(name)

    case InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_PASIBAIGIMA:
      if (hasRole(Roles.NOTARINIU_GRUPE)) {
        return [ 'MessageDetails', 'DataProvider', 'ObjectData', 'Principals', 'Representitives', 'ProvidedDataForm', 'Documents', 'ConfirmPerson', 'ChangeConfirmPerson'].includes(name)
      }
    case InJournalTypes.PRANESIMAS_APIE_PROKUROS_PASIBAIGIMA:
    case InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMA:
    case InJournalTypes.PRANESIMAS_APIE_PROKUROS_SUSTABDYMA:
    case InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMO_PANAIKINIMA:
    case InJournalTypes.PRANESIMAS_APIE_PROKUROS_SUSTABDYMO_PANAIKINIMA:
      return [ 'MessageDetails', 'DataProvider', 'ObjectData', 'Principals', 'Representitives', 'ProvidedDataForm', 'ConfirmPerson', 'Documents'].includes(name)

    case InJournalTypes.PRANESIMAS_APIE_NEZINIA_KUR_ESANTI_BENDRAS:
      return ['MessageDetails', 'DataProvider', 'RecognizedAsMissing', 'ObjectList', 'ProvidedDataForm', 'Documents'].includes(name)
      
    case InJournalTypes.TARNYBINIS_APIE_NETIKSLUMUS:
      return [ 'MessageDetails', 'DataProvider', 'ObjectData', 'ConfirmPerson', 'Principals', 'Representitives', 'ErrorsCorrectionData' , 'Documents'].includes(name)
    case InJournalTypes.TARNYBINIS_APIE_KLAIDINGAI_IREGISTRUOTA:
      return [ 'MessageDetails', 'DataProvider', 'ObjectData', 'ConfirmPerson' , 'Principals', 'Representitives', 'ProvidedDataForm' , 'Documents'].includes(name)
    
      default:
      return false
  }
}

export function store (formData, id, isErrorsCorrection) {
  let url = id ? `in-journals/notices/${id}` : `in-journals/notices`
  if(isErrorsCorrection){
    url = id ? `in-journals/official-notices/${id}` : `in-journals/official-notices`
  }
  return axios.post(url, formData)
}

export function getMandateByCode(code, search, type) {
  if(type){
    return axios.get(`mandates/byCode/${code}/${search}`, { params: { type: type } })
  }
  return axios.get(`mandates/byCode/${code}/${search}`)
}


export function addPersonsToFormData(formData, personKey, persons, addJurRepresenter) {
  if (persons.length > 0) {
    formData.append(`${personKey}`, []);
    Object.keys(persons).map((value, key) => {
      formData.append(`${personKey}[${key}][id]`, persons[key].id || '')
      formData.append(`${personKey}[${key}][amn_id]`, persons[key].amn_id || '')
      formData.append(`${personKey}[${key}][email_address]`, persons[key].email_address || '')
      formData.append(`${personKey}[${key}][phone_number_prepend]`, persons[key].phone_number_prepend || '')
      formData.append(`${personKey}[${key}][phone_number]`, persons[key].phone_number || '')
      formData.append(`${personKey}[${key}][sms_enabled]`, persons[key].sms_enabled ? "1" : "0")
      formData.append(`${personKey}[${key}][email_enabled]`, persons[key].email_enabled ? "1" : "0")
      formData.append(`${personKey}[${key}][foreigner_code]`, persons[key].foreigner_code || '')
      if (persons[key].amn_id.includes('new_id')) {
        formData.append(`${personKey}[${key}][name]`, persons[key].name || '')
        formData.append(`${personKey}[${key}][lastname]`, persons[key].lastname || '')
        formData.append(`${personKey}[${key}][fullname]`, persons[key].fullname || '')
        formData.append(`${personKey}[${key}][birth_date]`, persons[key].birth_date || '')
        formData.append(`${personKey}[${key}][country_code]`, persons[key].country || '')
        formData.append(`${personKey}[${key}][mandate_person_id]`, persons[key].mandate_person_id || '')
      }
      if (addJurRepresenter) {
        formData.append(`[${personKey}][${key}][jur_representers]`, [])
        if (persons[key].jur_representers) {
          Object.keys(persons[key].jur_representers).map((value, key2) => {
            formData.append(`${personKey}[${key}][jur_representers][${key2}][id]`, persons[key].jur_representers[key2].id || '')
            formData.append(`${personKey}[${key}][jur_representers][${key2}][amn_id]`, persons[key].jur_representers[key2].amn_id || '')
            formData.append(`${personKey}[${key}][jur_representers][${key2}][id]`, persons[key].jur_representers[key2].id || '')
            formData.append(`${personKey}[${key}][jur_representers][${key2}][email_address]`, persons[key].jur_representers[key2].email_address || '')
            formData.append(`${personKey}[${key}][jur_representers][${key2}][phone_number_prepend]`, persons[key].jur_representers[key2].phone_number_prepend || '')
            formData.append(`${personKey}[${key}][jur_representers][${key2}][phone_number]`, persons[key].jur_representers[key2].phone_number || '')
            formData.append(`${personKey}[${key}][jur_representers][${key2}][sms_enabled]`, persons[key].jur_representers[key2].sms_enabled ? "1" : "0")
            formData.append(`${personKey}[${key}][jur_representers][${key2}][email_enabled]`, persons[key].jur_representers[key2].email_enabled ? "1" : "0")
            formData.append(`${personKey}[${key}][jur_representers][${key2}][foreigner_code]`,  persons[key].jur_representers[key2].foreigner_code || '')
            if (persons[key].jur_representers[key2].amn_id.includes('new_id')) {
              formData.append(`${personKey}[${key}][jur_representers][${key2}][name]`,  persons[key].jur_representers[key2].name || '')
              formData.append(`${personKey}[${key}][jur_representers][${key2}][lastname]`,  persons[key].jur_representers[key2].lastname || '')
              formData.append(`${personKey}[${key}][jur_representers][${key2}][fullname]`,  persons[key].jur_representers[key2].fullname || '')
              formData.append(`${personKey}[${key}][jur_representers][${key2}][birth_date]`,  persons[key].jur_representers[key2].birth_date || '')
              formData.append(`${personKey}[${key}][jur_representers][${key2}][country_code]`,  persons[key].jur_representers[key2].country || '')
              formData.append(`${personKey}[${key}][jur_representers][${key2}][mandate_person_id]`, persons[key].jur_representers[key2].mandate_person_id || '')
            }
          })
        }
      }
    })
  }

  return formData;
}

export function prepareDataToSave(data) {
  let formData = new FormData()
  let totalFileSize = 0
  let emitError;
  let emitText = [];
  let fileTypes = sessionStorage.getItem('file_types')
  // Add Files
  if (data.in_journal_type == InJournalTypes.TARNYBINIS_APIE_NETIKSLUMUS || data.in_journal_type == InJournalTypes.TARNYBINIS_APIE_KLAIDINGAI_IREGISTRUOTA){
    if (data?.documents?.length > 0) {
      Object.keys(data.documents).map((value, key) => {
        if (data.documents[key].file !== undefined) {
          totalFileSize += data.documents[key].file.size
          let filename = data.documents[key].file.name
          let extension = filename.substr(filename.lastIndexOf('.') + 1)
  
          if (fileTypes.includes(extension.toLowerCase())) {
            formData.append(`documents[${key}]`, data.documents[key].file)
            formData.append(`show_in_statement[${key}]`, data.documents[key].show_in_statement)
          } else {
            emitError = 'FILE_EXTENSION_NOT_ALLOWED'
          }
        } else {
          formData.append(`show_in_statement[u-${data.documents[key].id}]`, data.documents[key].show_in_statement)
        }
      })
    }
  } else {
    if (data?.documents?.length > 0) {
      Object.keys(data.documents).map((value, key) => {
        if (data.documents[key].file !== undefined) {
          totalFileSize += data.documents[key].file.size
          let filename = data.documents[key].file.name
          let extension = filename.substr(filename.lastIndexOf('.') + 1)
  
          if (fileTypes.includes(extension.toLowerCase())) {
            formData.append(`documents[${key}]`, data.documents[key].file)
          } else {
            emitError = 'FILE_EXTENSION_NOT_ALLOWED'
          }
        }
      })
    }
  }

  if (([InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA, InJournalTypes.PRANESIMAS_APIE_PAKEITIMA].includes(data.in_journal_type) && data.mandate.principals.length == 0)
    || ([InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA, InJournalTypes.PRANESIMAS_APIE_PAKEITIMA].includes(data.in_journal_type) && data.mandate[data.mandate.parent ? 'sub_representitives' : 'representitives'].length == 0)  
  ) {
    emitError = 'DATA_ERROR_CODE'
    emitText.push('000102')
  }

  if (totalFileSize > sessionStorage.getItem('max_file_size')) {
    emitError = 'FILE_TOO_LARGE'
  }

  if (emitError !== undefined) {
    return {emitError: emitError, formData: formData, emitText: emitText};
  }

  formData = addDataBasedOnInJournalType(data, data.in_journal_type, formData)

  return {formData:formData, emitError: undefined};
}

export function setConfirmData(formData, data) {
    formData.append('request_number', data.request_number || '')
    formData.append('cancelable', data.mandate.cancelable == '1' ? '0' : '1')
    formData.append('confirm_date', data.mandate.confirm_date || '')
    formData.append('form_place', data.mandate.form_place || '')
    formData.append('notarial_no', data.mandate.notarial_no || '')
    formData.append('check_duplicates', data.check_duplicates || '')
    formData.append('notes', data.mandate.notes || '')
    formData.append('order_abroad', data.mandate.order_abroad ? "1" : "0")
    formData.append('submandate_allowed', data.mandate.submandate_allowed ? "1" : "0")
    formData.append('confirm_person_id', data.mandate.confirm_person_id || '')
    formData.append('confirm_person_fullname', data.mandate.confirm_person_fullname || '')
    formData.append('confirm_person_position', data.mandate.confirm_person_position || '')
    formData.append('term', data.mandate.term || '')
    formData.append('data_provider_amn_id', data.institution.amn_id || "")
    formData.append('representitive_amn_id', data.institution.representitive_amn_id || "")
    formData.append('representitive_position', data.institution.representitive_position || "")
    formData.append('representitive_name', data.institution.representitive_name || "")
    formData.append('representitive_lastname', data.institution.representitive_lastname || "")
    formData.append('principals_together', data.mandate.principals_together ? "1" : "0")
    formData.append('representitives_together', data.mandate.representitives_together ? "1" : "0")
    formData.append('sub_representitives_together', data.mandate.sub_representitives_together ? "1" : "0")
    formData.append('parent_id', data.mandate.parent?.id || "");
    if (data.mandate.term === Term.ByDate) {
      formData.append('term_date', data.mandate.term_date || '')
    } else if (data.mandate.term === Term.ByEvent) {
      formData.append('term_event', data.mandate.term_event || '')
    }
    formData.append('from_foreign_mandate', data.mandate.from_foreign_mandate ? '1' : '0')
    if (data.mandate.from_foreign_mandate) {
      formData.append('foreign_mandate_confirm_date', data.mandate.foreign_mandate_confirm_date || '')
      formData.append('foreign_mandate_notarial_no', data.mandate.foreign_mandate_notarial_no || '')
      formData.append('apostille_date', data.mandate.apostille_date || '')
      formData.append('apostille_number', data.mandate.apostille_number || '')
      formData.append('foreign_mandate_confirm_person', data.mandate.foreign_mandate_confirm_person || '')
    }

    return formData
}

export function setChangeData(formData, data) {
  formData.append('mandate_id', data.mandate.id || "")
  formData.append('change_confirm_date', data.change_confirm_date || '')
  formData.append('change_reason_id', data.change_reason_id || '')
  formData.append('change_notarial_no', data.change_notarial_no || '')
  formData.append('notarial_person_number', data.notarial_person_number || '')
  formData.append('change_notes', data.change_notes || '')
  formData.append('change_confirm_person_id', data.change_confirm_person_id || '')
  formData.append('change_confirm_person_fullname', data.change_confirm_person_fullname || '')
  formData.append('change_confirm_person_position', data.change_confirm_person_position || '')

  return formData;
}

export function addDataBasedOnInJournalType(data, type, formData) {
  if (data?.documentsToDelete?.length > 0) {
    Object.keys(data.documentsToDelete).map((value, key) => {
      formData.append(`documentsToDelete[${key}]`, data.documentsToDelete[key])
    })
  }

  formData.append('action', data.action || "")
  formData.append('in_journal_type', type || "")

  switch (type) {
    case InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA:
      formData = setConfirmData(formData, data)
      break;
    case InJournalTypes.PRANESIMAS_APIE_PAKEITIMA:
    case InJournalTypes.TARNYBINIS_APIE_NETIKSLUMUS:
      formData = setConfirmData(formData, data)
      formData = setChangeData(formData, data);
      break;

    case InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_PASIBAIGIMA:
    case InJournalTypes.PRANESIMAS_APIE_PROKUROS_PASIBAIGIMA:
    case InJournalTypes.TARNYBINIS_APIE_KLAIDINGAI_IREGISTRUOTA:
      formData.append('expiration_reason_description', data.providedData.expiration_reason_description || "")
      formData.append('expiration_reason_id', data.providedData.expiration_reason_id || "")
      formData.append('mandate_id', data.mandate.id || "")

      formData.append('request_number', data.request_number || "")
      formData.append('in_journal_type', data.in_journal_type || "")
      formData.append('basis_date', data.providedData.basis_date || "")

      if (!hasRole(Roles.NOTARINIU_GRUPE)) {
        formData.append('decision_date', data.providedData.court_decision_date || "")
        formData.append('court_id', data.providedData.court_id || "")
        formData.append('decision_number', data.providedData.decision_number || "")
      } else {
        formData.append('change_confirm_person_id', data.change_confirm_person_id || '')
        formData.append('change_confirm_person_fullname', data.change_confirm_person_fullname || '')
        formData.append('change_confirm_person_position', data.change_confirm_person_position || '')
        formData.append('change_notarial_no', data.providedData.change_notarial_no || '')
        formData.append('notarial_person_number', data.providedData.notarial_person_number || '')
      }

      if (hasRole([Roles.IR_REGISTRATORIUS])) {
        formData.append('data_provider_amn_id', data.institution.data_provider_amn_id || "")
        formData.append('representitive_position', data.institution.representitive_position || "")
        formData.append('representitive_name', data.institution.representitive_name || "")
        formData.append('representitive_lastname', data.institution.representitive_lastname || "")
      } else if (hasRole(Roles.NOTARINIU_GRUPE)) {
        formData.append('data_provider_amn_id', data.institution.amn_id || "")
        formData.append('representitive_amn_id', data.institution.representitive_amn_id || "")
        formData.append('representitive_position', data.institution.representitive_position || "")
        formData.append('representitive_name', data.institution.representitive_name || "")
        formData.append('representitive_lastname', data.institution.representitive_lastname || "")
      } else {
        formData.append('data_provider_amn_id', data.data_provider_amn_id || data.institution.amn_id ||"")
      }
      if(type == InJournalTypes.TARNYBINIS_APIE_KLAIDINGAI_IREGISTRUOTA){
        formData.append('data_provider_amn_id', data.institution.amn_id ||"")
        formData.append('change_notarial_no', data.providedData.change_notarial_no || '')
      }
      break;

    case InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMA:
    case InJournalTypes.PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMO_PANAIKINIMA:
    case InJournalTypes.PRANESIMAS_APIE_PROKUROS_SUSTABDYMA:
    case InJournalTypes.PRANESIMAS_APIE_PROKUROS_SUSTABDYMO_PANAIKINIMA:
      formData.append('suspension_reason_description', data.providedData.suspension_reason_description ?? "")
      formData.append('suspension_reason_id', data.providedData.suspension_reason_id ?? "")
      formData.append('mandate_id', data.mandate.id ?? "")
      formData.append('action', data.action ?? "")
      formData.append('request_number', data.request_number ?? "")
      formData.append('in_journal_type', data.in_journal_type ?? "")
      formData.append('basis_date', data.providedData.basis_date ?? "")
      formData.append('decision_date', data.providedData.court_decision_date ?? "")
      formData.append('court_id', data.providedData.court_id ?? "")
      formData.append('decision_number', data.providedData.decision_number ?? "")
      if (hasRole([Roles.IR_REGISTRATORIUS])) {
        formData.append('data_provider_amn_id', data.institution.data_provider_amn_id ?? "")
        formData.append('representitive_position', data.institution.representitive_position ?? "")
        formData.append('representitive_name', data.institution.representitive_name ?? "")
        formData.append('representitive_lastname', data.institution.representitive_lastname ?? "")
      } else {
        formData.append('data_provider_amn_id', data.data_provider_amn_id ?? "")
      }
      break;

    case InJournalTypes.PRANESIMAS_APIE_NEZINIA_KUR_ESANTI_BENDRAS:
      formData.append('person_amn_id', data.person_amn_id ?? "")
      formData.append('action', data.action ?? "")
      formData.append('request_number', data.request_number ?? "")
      formData.append('in_journal_type', data.in_journal_type ?? "")
      formData.append('basis_date', data.providedData.basis_date ?? "")
      formData.append('decision_date', data.providedData.court_decision_date ?? "")
      formData.append('court_id', data.providedData.court_id ?? "")
      formData.append('decision_number', data.providedData.decision_number ?? "")
      if (hasRole([Roles.IR_REGISTRATORIUS])) {
        formData.append('data_provider_amn_id', data.institution.data_provider_amn_id ?? "")
        formData.append('representitive_position', data.institution.representitive_position ?? "")
        formData.append('representitive_name', data.institution.representitive_name ?? "")
        formData.append('representitive_lastname', data.institution.representitive_lastname ?? "")
      } else {
        formData.append('data_provider_amn_id', data.data_provider_amn_id ?? "")
      }
      break;
    default: 
  }

  if (type != InJournalTypes.PRANESIMAS_APIE_NEZINIA_KUR_ESANTI_BENDRAS) {
    for (const personType of ['pro_principals', 'procurators', 'principals', 'representitives', 'sub_representitives']) {
      if (data.mandate[personType]) {
        formData = addPersonsToFormData(formData, personType, data.mandate[personType], ['pro_principals', 'principals'].includes(personType));
      }
    }
  }

  return formData;
}


